module.exports = __webpack_public_path__ + "static/media/candidateMembershipType.fe52e691.png";